export const emitContentTargetingEvent = data => {
  if (window.asos.contentTargeting) {
    window.asos.contentTargeting.emit(data);
  }
};

export const emitNewRelicEvent = data => {
  if (window.NREUM) {
    window.NREUM.addPageAction("globalBannerApiError", data);
  }
};



// WEBPACK FOOTER //
// ./template/state/modules/contentTargeting/events.js